import EngineModule from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'oms-processConfirmationModal') || new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'oms-processConfirmationModal',
	dependencies :     [
		'oms-basket'
	],
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath : null
});
